import React from 'react';
import { Button } from './ui/button';
import { Star, Phone, ArrowDown } from 'lucide-react';
import { businessInfo } from '../mock';

export const HeroSection = ({ heroImage, onBookConsultation, onViewWork }) => {
  const scrollDown = () => {
    window.scrollBy({ top: window.innerHeight * 0.8, behavior: 'smooth' });
  };

  return (
    <section className="relative w-full mt-14 sm:mt-16 md:mt-20">
      {/* Large Hero Image */}
      <div className="relative w-full h-[55vh] sm:h-[60vh] md:h-[70vh] lg:h-[80vh] xl:h-[85vh] overflow-hidden">
        <img 
          src="https://customer-assets.emergentagent.com/job_1fb2ae2e-514b-4c98-bafe-f224b06bbc59/artifacts/drfvwg7f_kitchen%204.1.jpg"
          alt="Bespoke Fitted Furniture - Premium Quality Work"
          className="w-full h-full object-cover"
        />
        
        {/* Overlay gradient for text readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
        
        {/* Content Overlay */}
        <div className="absolute bottom-0 left-0 right-0 pb-10 sm:pb-14 md:pb-16 lg:pb-20 px-4 sm:px-6 md:px-8 lg:px-12">
          <div className="max-w-7xl mx-auto">
            {/* Main Headline */}
            <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl font-bold text-white mb-1 sm:mb-2 md:mb-3 leading-tight drop-shadow-2xl tracking-tight">
              Custom Joinery & Carpentry
              <br />
              <span className="text-white text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl font-medium">
                Built with Precision
              </span>
            </h1>

            {/* Subheading */}
            <p className="text-xs sm:text-sm md:text-base lg:text-lg text-white/95 mb-4 sm:mb-5 md:mb-6 lg:mb-8 leading-relaxed drop-shadow-lg max-w-xl lg:max-w-2xl">
              {businessInfo.description}
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 max-w-md lg:max-w-lg">
              <Button
                size="lg"
                onClick={onBookConsultation}
                className="text-white px-4 sm:px-5 md:px-6 py-3 sm:py-4 md:py-5 text-xs sm:text-sm md:text-base rounded-xl shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 group w-full sm:w-auto"
                style={{ backgroundColor: '#1c2536' }}
              >
                <Phone className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-2 group-hover:rotate-12 transition-transform" />
                Book Free Consultation
              </Button>
              <Button
                size="lg"
                variant="outline"
                onClick={onViewWork}
                className="border-2 border-white text-white hover:bg-white hover:text-[#1c2536] px-4 sm:px-5 md:px-6 py-3 sm:py-4 md:py-5 text-xs sm:text-sm md:text-base rounded-xl backdrop-blur-sm hover:shadow-2xl transition-all duration-300 w-full sm:w-auto"
              >
                View Our Work
              </Button>
            </div>
          </div>
        </div>

        {/* Scroll indicator - hidden on small screens */}
        <button 
          onClick={scrollDown}
          className="hidden sm:block absolute bottom-4 sm:bottom-6 left-1/2 transform -translate-x-1/2 animate-bounce"
          aria-label="Scroll down"
        >
          <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/30 transition-colors">
            <ArrowDown className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
          </div>
        </button>
      </div>
    </section>
  );
};
